import { useMutation } from '@tanstack/react-query';
import { apiClient, ApiErrorResponse } from '../../common/ApiClient';
import { RcFile } from 'antd/es/upload';
import { InputDataUploadInfoType } from '../schema/types';
import { InputDataUrl } from './InputDataUrl';
import { InputDataUploadInfoSchema } from '../schema/InputDataSchema';

interface IArgs {
  file: string | Blob | RcFile;
}

export const useMutateInputDataUpload = (
  onProgress?: (progress: number) => void
) =>
  useMutation<InputDataUploadInfoType, ApiErrorResponse, IArgs>({
    mutationKey: ['inputDataUpload'],
    mutationFn: ({ file }) =>
      apiClient
        .post(
          InputDataUrl.INPUT_DATA_EXCEL,
          { file },
          {
            headers: { 'content-type': 'multipart/form-data' },
            onUploadProgress: (progress) => {
              if (!progress.total) {
                return;
              }
              onProgress?.((progress.loaded / progress.total) * 100);
            },
          }
        )
        .then((response) => InputDataUploadInfoSchema.parse(response.data)),
  });
